import { cn } from "../../helpers";
import { paragraph } from "../typography";

const tooltip = (className?: string) =>
  cn(
    "z-50 overflow-hidden rounded-2xl bg-black p-4 max-w-[250px] shadow-neutral-below-large animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
    className,
  );
const tooltipContent = cn(
  paragraph({ size: "sm" }),
  "text-neutral-300 whitespace-pre-line text-left",
);
const tooltipTrigger = cn("align-middle text-neutral-700");

export { tooltip, tooltipContent, tooltipTrigger };
